export default "__VITE_ASSET__CcOh$r0e__"